import React from 'react';
import { FormInstance } from 'antd';
import {
  Input,
  InputNumber,
  Modal,
} from 'UI';

import {
  FormContainer,
  BaseFormItem,
  InlineButton,
} from './style';

export interface HealingRoomFormData {
  name: string
  capacity: number
}

interface HealingRoomModalProps {
  formHandler: FormInstance
  onSubmit(data: unknown): void
  onCancel(): void
  curRoom?: HealingRoomFormData
  isLoading: boolean
  isVisible: boolean
}

const HealingRoomModal = ({
  formHandler,
  onSubmit,
  onCancel,
  curRoom,
  isLoading,
  isVisible,
}: HealingRoomModalProps): JSX.Element => (
  <Modal
    visible={isVisible}
    title={curRoom ? 'Editar sala de cicatrização' : 'Nova sala de cicatrização'}
    destroyOnClose
    onCancel={onCancel}
    afterClose={onCancel}
    zIndex={90}
    footer={[
      <InlineButton
        key="cancel"
        onClick={onCancel}
        type="ghost"
      >
        Cancelar
      </InlineButton>,
      <InlineButton
        key="submit"
        onClick={onSubmit}
        disabled={isLoading}
        loading={isLoading}
      >
        Salvar sala
      </InlineButton>,
    ]}
  >
    <FormContainer
      layout="vertical"
      form={formHandler}
      requiredMark={false}
      onFinish={onSubmit as (val: unknown) => void}
    >
      <BaseFormItem
        label="Nome"
        name="name"
        rules={[
          {
            required: true,
            message: 'Insira um nome',
          },
        ]}
        initialValue={curRoom?.name}
      >
        <Input disabled={isLoading} />
      </BaseFormItem>
      <BaseFormItem
        label="Capacidade"
        name="capacity"
        rules={[
          {
            required: true,
            message: 'Insira uma capacidade',
          },
        ]}
        initialValue={curRoom?.capacity}
      >
        <InputNumber min={0} disabled={isLoading} />
      </BaseFormItem>
    </FormContainer>
  </Modal>
);

HealingRoomModal.defaultProps = {
  curRoom: undefined,
};

export default HealingRoomModal;
